import { Container } from '@ui/container'
import Iframe from '@ui/iframe'
import React, { type FC } from 'react'

const BankFeesComparator: FC = () => (
  <Container>
    <Iframe
      className="h-[2300px] tablet:h-[1400px] laptop:h-[1140px]"
      title="comparateur-frais-bancaire"
      url="https://banque.meilleurtaux.com/comparateurs/b2b_fortuneo/index.php"
    />
  </Container>
)

export default BankFeesComparator
